import _ from 'underscore';
import { IProcessor, IRawLogs } from '../types';

export class ScenarioProcessor implements IProcessor {
  process(rawLogs: IRawLogs): IRawLogs {
    // Although IRawLogs now requires a scenario property after deduplication,
    // we still perform the check to maintain the original runtime behavior.
    if (!_.has(rawLogs, 'scenario')) {
      return rawLogs;
    }

    let logs = _.extend(rawLogs, {
      activityId: rawLogs.activity!.id,
      activityName: rawLogs.activity!.value,
      scenarioId: rawLogs.scenario!.id,
      scenarioName: rawLogs.scenario!.value,
      parentScenarioId: rawLogs.parentScenario ? rawLogs.parentScenario.id : undefined,
      parentScenarioName: rawLogs.parentScenario ? rawLogs.parentScenario.value : undefined,
    });

    // Drop activity/scenario/parentScenario since we've already extracted the needed info
    logs = _.omit(logs, 'activity', 'scenario', 'parentScenario');

    return logs;
  }
}
